import { useTranslation } from 'react-i18next';
import React from 'react';

const TrendingIcon = ({ color, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
    <polyline points="17 6 23 6 23 12"></polyline>
  </svg>
);

const CheckIcon = ({ color, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
);

const ClockIcon = ({ color, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

const AlertIcon = ({ color, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </svg>
);

export default function StatsHeader({ data }) {
  const { t } = useTranslation();

  const STAT_LABELS = {
    collected: { label: t('financialHub.totalCollected'), color: '#4ade80', icon: <CheckIcon color="#4ade80" /> },
    pending: { label: t('financialHub.pendingArrears'), color: '#fbbf24', icon: <ClockIcon color="#fbbf24" /> },
    overdue: { label: t('financialHub.criticalOverdue'), color: '#fca5a5', icon: <AlertIcon color="#fca5a5" /> }
  };

  if (!data) return null;

  return (
    <div className="stats-header-card">
      <div className="stats-header-top">
        <div>
          <div style={{ fontSize: 13, textTransform: 'uppercase', letterSpacing: 2, opacity: 0.8, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
            <TrendingIcon color="#d4af37" />
            <span style={{ color: '#d4af37', fontWeight: 700 }}>{t('financialHub.monthlyCashflow')}</span>
          </div>
          <h1 className="stats-header-title" style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
            ${data.summary.projectedRevenue.toLocaleString()} <span style={{ fontSize: 20, opacity: 0.6, fontWeight: 500 }}>HKD</span>
          </h1>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 12 }}>
            <div style={{ width: 140, height: 6, background: 'rgba(255,255,255,0.15)', borderRadius: 10, overflow: 'hidden' }}>
              <div style={{ width: `${data.summary.collectionRate}%`, height: '100%', background: '#4ade80', borderRadius: 10 }}></div>
            </div>
            <span style={{ fontSize: 13, fontWeight: 700, color: '#4ade80', letterSpacing: 0.5 }}>{data.summary.collectionRate}% {t('financialHub.collectedPct')}</span>
          </div>
        </div>
        
        <div className="stats-header-quick-stats">
           <div style={{ textAlign: 'right', paddingRight: 20, borderRight: '1px solid rgba(255,255,255,0.2)' }}>
              <div style={{ fontSize: 32, fontWeight: 900 }}>{data.summary.totalStudents}</div>
              <div style={{ fontSize: 11, opacity: 0.7, textTransform: 'uppercase', letterSpacing: 1, marginTop: 4 }}>{t('financialHub.activeStudents')}</div>
           </div>
           <div style={{ textAlign: 'left', paddingLeft: 8 }}>
              <div style={{ fontSize: 32, fontWeight: 900, color: '#fca5a5' }}>{data.counts.overdue}</div>
              <div style={{ fontSize: 11, opacity: 0.7, textTransform: 'uppercase', letterSpacing: 1, marginTop: 4 }}>{t('financialHub.overdueAccounts')}</div>
           </div>
        </div>
      </div>

      <div className="stats-header-grid">
        {['collected', 'pending', 'overdue'].map(key => (
          <div key={key} className="stats-header-grid-card">
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 16 }}>
              {STAT_LABELS[key].icon}
              {STAT_LABELS[key].label}
            </div>
            <div style={{ fontSize: 28, fontWeight: 800, color: STAT_LABELS[key].color }}>
              ${data.summary[key].toLocaleString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
